import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Image from 'next/image'

import { FadeUp } from '@happymoneyinc/move'

import Button from '../Button'
import Container from '../Container'
import Headline from '../Headline'
import Text from '../Text'
import Quote from '../Quote'
import BorderBox from '../BorderBox'

const Perks = (props) => {
  const {
    data: {
      perks_lead_text: leadText,
      perks_quote: quote,
      perks_quotee: quotee,
      perks: perksItems,
      perks_button_eyebrow: button_eyebrow,
      perks_button_href: button_href,
      perks_button_text: button_text,
    }
  } = props

  return (
    <Wrapper>
      <FadeUp>
        <LeadText>{leadText}</LeadText>
        <BorderBox>
          <Quote size="medium">{quote}</Quote>
          <Quotee size="eyebrow">{`- ${ quotee }`}</Quotee>
        </BorderBox>
        <List>
          {perksItems.map((item, index) => (
            <ListItem index={index} key={item.headline}>
              <ImageWrapper imageWidth={item.image_max_width}>
                <Image alt={item.image.alt} src={item.image.url} height={item.image.dimensions.height} width={item.image.dimensions.width} />
              </ImageWrapper>

              <TextWrapper>
                <ItemHeadline size="medium">{item.headline}</ItemHeadline>
                <Text size="large">{item.text}</Text>
              </TextWrapper>
            </ListItem>
          ))}
        </List>

        <CTAWrapper>
          <Eyebrow size="buttonEyebrow">{button_eyebrow}</Eyebrow>
          {button_text && <Button buttonHref={button_href} buttonContent={button_text} color="azure" />}
        </CTAWrapper>
      </FadeUp>
    </Wrapper>
  )
}

const Wrapper = styled(Container)`
  text-align: center;
  background-color: ${ ({ theme }) => theme.colors.cream };
`

const LeadText = styled(Headline)`
  max-width: 666px;
  margin: 60px auto 100px;

  @media screen and (min-width: ${ ({ theme }) => theme.breakpoints.sm }) {
    margin: 30px auto 100px;
  }
`

const Quotee = styled(Text)`
  margin: 50px auto 0;
  text-transform: uppercase;
`
const List = styled.ul`
  display: grid;
  padding: 0;
  margin: 120px auto;
  margin-bottom: 80px;
  list-style: none;
  grid-row-gap: 90px;

  @media screen and (min-width: ${ (props) => props.theme.breakpoints.md }) {
    margin: 120px 0;
    grid-row-gap: 120px;
  }
`

const ListItem = styled.li`
  flex-direction: column;
  justify-content: space-between;
  display: flex;
  width: 100%;
  max-width: 890px;
  margin: 0 auto;
  gap: 50px;

  @media screen and (min-width: ${ (props) => props.theme.breakpoints.sm }) {
    flex-direction:
    ${ ({ index }) => {
    if (index === 1) return 'row'
    return 'row-reverse'
  } };
  }

  ${ ({ index }) => index === 1 && css`
        max-width: 1000px;
        margin: initial;
    ` }
`

const ImageWrapper = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  padding: 0 25px;

  @media screen and (min-width: ${ (props) => props.theme.breakpoints.sm }) {
    padding: 0;
  }

  @media screen and (min-width: ${ (props) => props.theme.breakpoints.md }) {
    width: ${ ({ imageWidth }) => `${ imageWidth }px` };
  }
`

const TextWrapper = styled.div`
  flex-basis: 39%;
  flex-direction: column;
  justify-content: center;
  display: flex;
  text-align: left;

  @media screen and (min-width: ${ (props) => props.theme.breakpoints.sm }) {
    max-width: 322px;
  }
`

const ItemHeadline = styled(Headline)`
  margin-bottom: 0;
`

const CTAWrapper = styled.div`
  align-items: center;
  flex-direction: column;
  justify-content: center;
  display: flex;
`
const Eyebrow = styled(Text)`
  width: 100%;
  margin-top: 0;
`

Perks.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
}

export default Perks
